export class Catalog {
    id: string = "";
    name: string = "";
    description: string = "";
    notes: string = "";

    quantity: number = 0;
    deleted: boolean = false;

    products: string[];
}



// WEBPACK FOOTER //
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/src/app/agatextscreens/purchasing/catalogs/catalog.ts